import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as ALOOMA from 'consts/alooma';
import { getList } from 'store/lists/selectors';
import ModalBodyListShare from 'components/molecules/ModalBodyListShare/ModalBodyListShare';
import Modal from 'components/templates/Modal/Modal';

const ModalListShare = props => {
  const { closeModal, listId } = props;
  const list = useSelector(getList)(listId);

  return (
    <Modal source={ALOOMA.SOURCE_PAGES.MODAL_LIST_SHARE} onClose={closeModal}>
      <ModalBodyListShare list={list} {...props} />
    </Modal>
  );
};

ModalListShare.propTypes = {
  closeModal: PropTypes.func.isRequired,
  listId: PropTypes.number.isRequired,
};

export default ModalListShare;
